/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoApiRoleUpdateRequest model module.
 * @module model/SystemControllerDtoApiRoleUpdateRequest
 * @version 1.0
 */
class SystemControllerDtoApiRoleUpdateRequest {
    /**
     * Constructs a new <code>SystemControllerDtoApiRoleUpdateRequest</code>.
     * @alias module:model/SystemControllerDtoApiRoleUpdateRequest
     */
    constructor() { 
        
        SystemControllerDtoApiRoleUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemControllerDtoApiRoleUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoApiRoleUpdateRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoApiRoleUpdateRequest} The populated <code>SystemControllerDtoApiRoleUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoApiRoleUpdateRequest();

            if (data.hasOwnProperty('apiUrl')) {
                obj['apiUrl'] = ApiClient.convertToType(data['apiUrl'], 'String');
            }
            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
            if (data.hasOwnProperty('subNo')) {
                obj['subNo'] = ApiClient.convertToType(data['subNo'], 'Number');
            }
            if (data.hasOwnProperty('dontReadonly')) {
                obj['dontReadonly'] = ApiClient.convertToType(data['dontReadonly'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoApiRoleUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoApiRoleUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['apiUrl'] && !(typeof data['apiUrl'] === 'string' || data['apiUrl'] instanceof String)) {
            throw new Error("Expected the field `apiUrl` to be a primitive type in the JSON string but got " + data['apiUrl']);
        }

        return true;
    }


}



/**
 * @member {String} apiUrl
 */
SystemControllerDtoApiRoleUpdateRequest.prototype['apiUrl'] = undefined;

/**
 * @member {Number} gnbNo
 */
SystemControllerDtoApiRoleUpdateRequest.prototype['gnbNo'] = undefined;

/**
 * @member {Number} lnbNo
 */
SystemControllerDtoApiRoleUpdateRequest.prototype['lnbNo'] = undefined;

/**
 * @member {Number} subNo
 */
SystemControllerDtoApiRoleUpdateRequest.prototype['subNo'] = undefined;

/**
 * @member {Boolean} dontReadonly
 */
SystemControllerDtoApiRoleUpdateRequest.prototype['dontReadonly'] = undefined;






export default SystemControllerDtoApiRoleUpdateRequest;

